var _createClass = require("/codebuild/output/src3412059884/src/qf-app-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/codebuild/output/src3412059884/src/qf-app-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var Packet = /*#__PURE__*/_createClass(function Packet() {
  "use strict";

  _classCallCheck(this, Packet);
  this.cmd = null;
  this.retain = false;
  this.qos = 0;
  this.dup = false;
  this.length = -1;
  this.topic = null;
  this.payload = null;
});
module.exports = Packet;